import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
    PaymethodWizard,
    PaymethodWizardCheckedEvent,
} from '../../../../shared/state/paymethod-wizard/paymethod-wizard.model';
import { Platform } from '@ionic/angular';

@Component({
    selector: 'app-paymethod-item',
    templateUrl: './paymethod-item.component.html',
    styleUrls: ['./paymethod-item.component.scss'],
})
export class PaymethodItemComponent implements OnInit {
    @Input() paymethod: PaymethodWizard;
    @Input() shippingEnabled: string;

    @Output() paymethodCheckedEvent = new EventEmitter<
        PaymethodWizardCheckedEvent
    >();
    @Output() paymethodClickedEvent = new EventEmitter<PaymethodWizard>();
    @Output() paymethodToggleEvent = new EventEmitter<PaymethodWizard>();

    ios;

    constructor(private platform: Platform) {
        this.ios = this.platform.is('ios');
    }

    ngOnInit(): void {}

    //TODO. Por qué hay 3 eventos muy parecidos si con 1 solo basta?
    onPaymethodChecked(paymethod: PaymethodWizard, event) {
        this.paymethodCheckedEvent.emit({
            paymethod,
            checkedEvent: event.currentTarget.checked,
        });
    }

    onPaymethodClicked(paymethodWizard: PaymethodWizard) {
        this.paymethodClickedEvent.emit(paymethodWizard);
    }

    onPaymethodToggle(paymethodWizard: PaymethodWizard) {
        this.paymethodToggleEvent.emit(paymethodWizard);
    }
}
